import { AdminGuard } from './guards/admin.guard';
import { Routes } from '@angular/router';
import { AuthGuard} from './guards/auth.guard';
//import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { GlobalLayoutComponent } from './layouts/global/global-layout.component';
import { WebComponent } from './layouts/web/web.component';

export const AppRoutes: Routes = [

  {path: 'web', component: WebComponent},
 /* {
  path: 'a',
  component: AdminLayoutComponent,
  children: [
  //{ path: '', loadChildren: './dashboard/dashboard.module#DashboardModule', canActivate:[AuthGuard]},
  { path: 'widgets', loadChildren: './widgets/widgets.module#WidgetsModule',canActivate:[AuthGuard]},
  { path: 'pages', loadChildren: './pages/pages.module#PagesModule', canActivate:[AuthGuard]}
  ]
  },*/ {
  path: '',
  component: GlobalLayoutComponent,
  children: [
  { path: '', loadChildren: './apps/apps.module#AppsModule', canActivate: [AuthGuard] },
  { path: 'ecommerce', loadChildren: './ecommerce/ecommerce.module#EcommerceModule', canActivate: [AuthGuard] },
  { path: 'company', loadChildren: './company/company.module#CompanyModule', canActivate: [AuthGuard]}, //AdminGuard
  { path: 'maps', loadChildren: './maps/maps.module#MapModule', canActivate: [AuthGuard] },
  { path: 'forms', loadChildren: './forms/forms.module#FormModule', canActivate: [AuthGuard]},
  { path: 'apps', loadChildren: './apps/apps.module#AppsModule', canActivate: [AuthGuard] },
  { path: 'media', loadChildren: './apps/apps.module#AppsModule', canActivate: [AuthGuard]}
  ]
}, {
  path: '', component: AuthLayoutComponent,
  children: [
    { path: 'session', loadChildren: './session/session.module#SessionModule' }
  ]
}, {
  path: '**',
  redirectTo: 'session/404'
}];



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/app.routing.ts